// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/bg_main.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* rubik-mono-one-latin-400-normal */
@font-face {
  font-family: "Rubik Mono One";
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/latin-400-normal.woff2) format("woff2"), url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/latin-400-normal.woff) format("woff");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* rubik-mono-one-cyrillic-400-normal */
@font-face {
  font-family: "Rubik Mono One";
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/cyrillic-400-normal.woff2) format("woff2"), url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/cyrillic-400-normal.woff) format("woff");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
:root {
  --max-width: 1440px;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  color: inherit;
}

.trashcan {
  cursor: pointer;
  position: absolute;
  top: 120%;
  left: 45%;
}

.background {
  min-height: 100vh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: repeat;
}

.content {
  margin: 0 auto;
  padding: 36px 82px;
}

.header {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  gap: 20px;
}
.header_block_border-wrap {
  background-image: linear-gradient(to bottom right, #52B35B 45%, #144D1A 55%), linear-gradient(to top left, #52B35B 45%, #144D1A 55%);
  background-size: 100% 100%;
  border-radius: 28px;
  padding: 6px;
}
.header_block {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #307D38;
  padding: 26px 36px;
  border-radius: 25px;
  color: #E0FFE3;
  text-transform: uppercase;
  font-size: 24px;
  line-height: 28px;
  white-space: nowrap;
}
.header_block img {
  width: 100%;
}

.header_center {
  display: none;
}

.green-button {
  cursor: pointer;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 12px;
  height: 56px;
  border: 3px solid #7EDB88;
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  color: #E0FFE3;
  text-stroke: 1.47px #3FA449;
  -webkit-text-stroke: 1.47px #3FA449;
  font-family: Rubik, serif;
  padding: 16px 20px;
  width: 100%;
  background: linear-gradient(to bottom, #4DBB26 0%, #67D650 20%, #2BB130 70%, #1DA011 85%, #57A20C 100%);
}
.green-button_arrow {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.orange-button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  width: 100%;
  border-radius: 12px;
  border: 2.5px solid #EDF4DF;
  background: linear-gradient(to bottom, #F6E865 0%, #F6E865 10%, #F7931D 65%, #EC8A17 75%, #C86000 100%);
}

.brown-bar {
  cursor: pointer;
  background-color: #C67A34;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2.5px solid #D8E6DA;
  border-radius: 12px;
  padding: 9px 16px;
  margin-right: 12px;
  height: 56px;
}
.brown-bar img[src="../grid.svg"] {
  margin-right: 12px;
}
.brown-bar img[src="../барысы да.svg"] {
  width: 137px;
  height: 24px;
  margin-top: 2px;
}

.orange-bar {
  cursor: pointer;
  background: linear-gradient(to bottom, #F6E865 0%, #F7931D 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2.5px solid #F2FFF4;
  border-radius: 12px;
  padding: 9px 16px;
  height: 56px;
}
.orange-bar img[src="../star.svg"] {
  margin-right: 12px;
}
.orange-bar img[src="../favoritesMode.svg"] {
  width: 175px;
  height: 24px;
  margin-bottom: 4px;
}

.top-menu {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 28px;
}
.top-menu-item {
  background-color: #1F4822;
  border-radius: 100px;
  font-family: var(--font-rubik);
  color: #7EDB88;
  cursor: pointer;
  padding: 8px 16px;
  text-transform: uppercase;
  margin-right: 8px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
}
.top-menu-item-active {
  color: white;
  border: 2px solid #7EDB88;
  background: linear-gradient(to bottom, #4DBB26 0%, #67D650 15%, #2BB130 65%, #1DA011 85%, #57A20C 100%);
}

@media screen and (max-width: 1300px) {
  .header {
    grid-template-columns: 1fr;
  }
  .header_block_header {
    justify-content: center !important;
  }
  .header_block {
    padding: 16px 20px;
    justify-content: space-between;
  }
  .header_block img {
    width: auto;
  }
  .header_side {
    display: none;
  }
  .header_center {
    display: flex;
  }
}
@media screen and (max-width: 1024px) {
  .content {
    padding: 36px 42px;
  }
  .header_block {
    padding: 16px 20px;
    font-size: 20px;
    line-height: 24px;
  }
  .header_block_border-wrap {
    padding: 3px;
  }
}
@media screen and (max-width: 768px) {
  .header_block {
    font-size: 16px;
    line-height: 20px;
    padding: 8px 12px;
    border-radius: 12px;
  }
  .header_block .header_button {
    height: 100%;
    width: 109px;
  }
  .header_block img {
    width: 100%;
  }
  .header_block_border-wrap {
    padding: 3px;
    border-radius: 16px;
  }
}
@media screen and (max-width: 600px) {
  .header {
    gap: 14px;
  }
  .content {
    padding: 24px 23px;
  }
  .header_block {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/globals.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oCAAA;AACA;EACE,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2NAAA;EACA,iMAAA;AACF;AAEA,uCAAA;AACA;EACE,6BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iOAAA;EACA,oEAAA;AAAF;AAGA;EACE,mBAAA;AADF;;AAIA;EACE,sBAAA;EACA,UAAA;EACA,SAAA;AADF;;AAIA;EACE,qBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AADF;;AAIA;EACE,iBAAA;EACA,yDAAA;EACA,wBAAA;EACA,yBAAA;AADF;;AAIA;EACE,cAAA;EACA,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,kCAAA;EACA,SAAA;AADF;AAEE;EACE,oIAAA;EAEA,0BAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAGE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AADJ;AAEI;EACE,WAAA;AAAN;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,uGAAA;AAFF;AAGE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AADJ;;AAKA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,uGAAA;AAHF;;AAMA;EACE,eAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAHF;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,YAAA;EACA,YAAA;EACA,eAAA;AAFJ;;AAMA;EACE,eAAA;EACA,gEAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAHF;AAIE;EACE,kBAAA;AAFJ;AAIE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;AAFJ;;AAMA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAHF;AAIE;EACE,yBAAA;EACA,oBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,YAAA;EACA,yBAAA;EACA,uGAAA;AAFJ;;AAMA;EAEE;IACE,0BAAA;EAJF;EAOA;IACE,kCAAA;EALF;EAQA;IACE,kBAAA;IACA,8BAAA;EANF;EAOE;IACE,WAAA;EALJ;EASA;IACE,aAAA;EAPF;EAUA;IACE,aAAA;EARF;AACF;AAWA;EACE;IACE,kBAAA;EATF;EAYA;IACE,kBAAA;IACA,eAAA;IACA,iBAAA;EAVF;EAaA;IACE,YAAA;EAXF;AACF;AAcA;EACE;IACE,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,mBAAA;EAZF;EAaE;IACE,YAAA;IACA,YAAA;EAXJ;EAaE;IACE,WAAA;EAXJ;EAeA;IACE,YAAA;IACA,mBAAA;EAbF;AACF;AAgBA;EAEE;IACE,SAAA;EAfF;EAkBA;IACE,kBAAA;EAhBF;EAmBA;IACE,mBAAA;EAjBF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');\n\n/* rubik-mono-one-latin-400-normal */\n@font-face {\n  font-family: 'Rubik Mono One';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/latin-400-normal.woff2) format('woff2'), url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/latin-400-normal.woff) format('woff');\n  unicode-range: U+0000-00FF,U+0131,U+0152-0153,U+02BB-02BC,U+02C6,U+02DA,U+02DC,U+0304,U+0308,U+0329,U+2000-206F,U+2074,U+20AC,U+2122,U+2191,U+2193,U+2212,U+2215,U+FEFF,U+FFFD;\n}\n\n/* rubik-mono-one-cyrillic-400-normal */\n@font-face {\n  font-family: 'Rubik Mono One';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/cyrillic-400-normal.woff2) format('woff2'), url(https://cdn.jsdelivr.net/fontsource/fonts/rubik-mono-one@latest/cyrillic-400-normal.woff) format('woff');\n  unicode-range: U+0301,U+0400-045F,U+0490-0491,U+04B0-04B1,U+2116;\n}\n\n:root {\n  --max-width: 1440px;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.trashcan {\n  cursor: pointer;\n  position: absolute;\n  top: 120%;\n  left: 45%;\n}\n\n.background {\n  min-height: 100vh;\n  background-image: url(\"./assets/bg_main.jpg\");\n  background-size: contain;\n  background-repeat: repeat;\n}\n\n.content {\n  margin: 0 auto;\n  padding: 36px 82px;\n}\n\n.header {\n  display: grid;\n  grid-template-columns: 1fr 3fr 1fr;\n  gap: 20px;\n  &_block_border-wrap {\n    background-image: linear-gradient(to bottom right, #52B35B 45%, #144D1A 55%),\n    linear-gradient(to top left, #52B35B 45%, #144D1A 55%);\n    background-size: 100% 100%;\n    border-radius: 28px;\n    padding: 6px;\n  }\n  &_block {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #307D38;\n    padding: 26px 36px;\n    border-radius: 25px;\n    color: #E0FFE3;\n    text-transform: uppercase;\n    font-size: 24px;\n    line-height: 28px;\n    white-space: nowrap;\n    img {\n      width: 100%;\n    }\n  }\n}\n\n.header_center {\n  display: none;\n}\n\n.green-button {\n  cursor: pointer;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  border-radius: 12px;\n  height: 56px;\n  border: 3px solid #7EDB88;\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 900;\n  color: #E0FFE3;\n  text-stroke: 1.47px #3FA449;\n  -webkit-text-stroke: 1.47px #3FA449;\n  font-family: Rubik, serif;\n  padding: 16px 20px;\n  width: 100%;\n  background: linear-gradient(to bottom, #4DBB26 0%, #67D650 20%, #2BB130 70%, #1DA011 85%, #57A20C 100%);\n  &_arrow {\n    width: 32px;\n    height: 32px;\n    margin-right: 12px;\n  }\n}\n\n.orange-button {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  //padding: 16px 76px;\n  padding: 16px;\n  width: 100%;\n  border-radius: 12px;\n  border: 2.5px solid #EDF4DF;\n  background: linear-gradient(to bottom, #F6E865 0%, #F6E865 10%, #F7931D 65%, #EC8A17 75%, #C86000 100%);\n}\n\n.brown-bar {\n  cursor: pointer;\n  background-color: #C67A34;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2.5px solid #D8E6DA;\n  border-radius: 12px;\n  padding: 9px 16px;\n  margin-right: 12px;\n  height: 56px;\n  img[src='../grid.svg'] {\n    margin-right: 12px;\n  }\n  img[src='../барысы да.svg'] {\n    width: 137px;\n    height: 24px;\n    margin-top: 2px;\n  }\n}\n\n.orange-bar {\n  cursor: pointer;\n  background: linear-gradient(to bottom, #F6E865 0%, #F7931D 100%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2.5px solid #F2FFF4;\n  border-radius: 12px;\n  padding: 9px 16px;\n  height: 56px;\n  img[src='../star.svg'] {\n    margin-right: 12px;\n  }\n  img[src='../favoritesMode.svg'] {\n    width: 175px;\n    height: 24px;\n    margin-bottom: 4px;\n  }\n}\n\n.top-menu {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 28px;\n  &-item {\n    background-color: #1F4822;\n    border-radius: 100px;\n    font-family: var(--font-rubik);\n    color: #7EDB88;\n    cursor: pointer;\n    padding: 8px 16px;\n    text-transform: uppercase;\n    margin-right: 8px;\n    font-weight: 500;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n  &-item-active {\n    color: white;\n    border: 2px solid #7EDB88;\n    background: linear-gradient(to bottom, #4DBB26 0%, #67D650 15%, #2BB130 65%, #1DA011 85%, #57A20C 100%);\n  }\n}\n\n@media screen and (max-width: 1300px) {\n\n  .header {\n    grid-template-columns: 1fr;\n  }\n\n  .header_block_header {\n    justify-content: center !important;\n  }\n\n  .header_block {\n    padding: 16px 20px;\n    justify-content: space-between;\n    img {\n      width: auto;\n    }\n  }\n\n  .header_side {\n    display: none;\n  }\n\n  .header_center {\n    display: flex;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .content {\n    padding: 36px 42px;\n  }\n\n  .header_block {\n    padding: 16px 20px;\n    font-size: 20px;\n    line-height: 24px;\n  }\n\n  .header_block_border-wrap {\n    padding: 3px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .header_block {\n    font-size: 16px;\n    line-height: 20px;\n    padding: 8px 12px;\n    border-radius: 12px;\n    .header_button {\n      height: 100%;\n      width: 109px;\n    }\n    img {\n      width: 100%;\n    }\n  }\n\n  .header_block_border-wrap {\n    padding: 3px;\n    border-radius: 16px;\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .header {\n    gap: 14px;\n  }\n\n  .content {\n    padding: 24px 23px;\n  }\n\n  .header_block {\n    white-space: normal;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
